import "react-sortable-tree/style.css";
import {
  Checkbox,
  Button,
  Drawer,
  Dialog,
  DialogContent,
  Grid,
  makeStyles,
  Paper,
  FormControl,
  InputAdornment,
  OutlinedInput,
  MenuItem,
  withStyles,
  InputBase,
  Select,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, PaginationItem } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";

import "../../../styles/tree-styles.css";
import ActionMessages from "../../../common-components/ActionMessages";
import ConfirmationDialog from "../../../common-components/ConfirmationDialog";
import CustomTextField from "../../../common-components/CustomTextField";
import Loading from "../../../common-components/Loading";
import {
  getGeneralSettingsLocation,
  updateGeneralSettingsLocation,
  updateSkills,
  updateRoles,
  updateDepartments,
  getSkills,
  getAdminDepartments,
  getRoles,
  downloadCreateRoleTemplateExcelFile,
  createRoleFromExcel,
} from "../../../actions/admin-actions";
import {
  downloadFile,
  getPaginationPageNumber,
} from "../../../shared-resources/utils";
import { created_by } from "../../../shared-resources/dumpData";
import { Select as AntSelect } from "antd";
import {
  UploadIcon,
  DownloadTemplateIcon,
} from "../../../shared-resources/SVGIcons";
import FileUpload from "../../../common-components/FileUpload";

const { Option } = AntSelect;
const SettingsList = ({ data, type, departmentsList }) => {
  const useStyles = makeStyles((theme) => ({
    tablePaper: {
      borderRadius: "12px",
      padding: "12px",
    },
    checkCircleIcon: {
      fontSize: "18px",
      color: "#075e07",
      cursor: "pointer",
      marginTop: "2px",
    },
    checkCircleIconSpan: {
      cursor: "pointer",
      marginLeft: "2px",
    },
    paginationSection: {
      marginTop: "4px",
    },
    searchSection: {
      marginBottom: "4px",
    },
    searchIcon: {
      color: "#ccc",
    },
    searchTextField: {
      borderRadius: "25px",
      fontSize: "14px",
      height: "36px",
    },
    editIcon: {
      fontSize: "16px",
      color: "#0070D2",
      cursor: "pointer",
    },
    editTextField: {
      height: "24px",
      fontSize: "12px",
      width: "180px",
      padding: "2px",
      background: "#fff",
    },
    editText: {
      padding: "0",
    },
    locationField: {
      height: "36px",
      borderRadius: "25px",
      fontSize: "13px",
    },
    addDialog: {
      width: "350px",
      height: "auto",
      position: "relative",
    },
    addBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      margin: "2px 0 2px 15px",
    },
    addRoleBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      position: "absolute",
      right: "-32px",
      top: "4px",
    },
    updateBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      marginRight: "8px",
    },
    departmentDropdown: {
      marginLeft: "15px",
      marginTop: "2px",
      width: "225px",
    },
    departmentDropdownPopup: {
      width: "100%",
    },

    closeSection: {
      position: "absolute",
      cursor: "pointer",
      right: theme.spacing(0.25),
      top: theme.spacing(0.25),
    },
    closeIcon: {
      color: "#C4C4C4",
    },
    drawerDataSection: {
      position: "relative",
      padding: "6px 32px",
    },
    drawerTitle: {
      color: "#0082CA",
      fontSize: theme.spacing(2.25),
      marginBottom: theme.spacing(2),
    },
    uploadDescription: {
      marginBottom: theme.spacing(2),
    },

    addColumnBtn: {
      fontSize: "13px",
      fontWeight: "600",
      padding: "4px 12px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      borderRadius: "15px",
      color: "#3599d1",
      backgroundColor: "#fff !important",
      marginTop: "12px",
    },
    addColumnTitle: {
      height: "28px",
      textAlign: "center",
      marginBottom: "11px",
      fontWeight: 600,
      paddingTop: "5px",
      color: "#ffff",
    },
    closeIconAdd: {
      display: "inline-block",
      color: "black",
      background: "#ffff",
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      cursor: "pointer",
      textAlign: "center",
      position: "absolute",
      top: "5px",
      right: "8px",
      fontSize: "13px",
      fontWeight: 600,
    },
    addDialog: {
      width: "350px",
      height: "auto",
      position: "relative",
    },

    cancelBtn: {
      fontSize: "12px",
      padding: "3px 8px !important",
      textTransform: "none",
      border: "0.5px solid #0176D3",
      color: "#0176D3",
    },
    saveBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      marginRight: "8px",
    },

    required: {
      color: "red",
    },
    popupBtnsAdd: {
      textAlign: "center",
      marginTop: "24px",
    },
    popupHeader: {
      marginTop: "-20px",
      marginLeft: "-24px",
      marginRight: "-24px",
      background: "#4b5558",
    },
    fieldTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      fontSize: "13px",
    },
  }));

  const classes = useStyles();
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isEnabled, setIsEnabled] = useState(false);
  const [hasExceededLimit, setHasExceededLimit] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [newValue, setNewValue] = useState("");
  const [roleCode, setRoleCode] = useState("");
  const [isValueUpdated, setIsValueUpdated] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [keys, setKeys] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [openDrawerUpload, setOpenDrawerUpload] = useState(false);
  const [isDownloadClick, setIsDownloadClick] = useState(false);
  const [isUploadClick, setIsUploadClick] = useState(false);
  const [openDialogAdd, setOpenDialogAdd] = useState(false);

  const upadteLocationSettingsData = useSelector(
    (state) => state.adminReducer.upadteLocationSettingsData
  );

  const updateRolesData = useSelector(
    (state) => state.adminReducer.updateRolesData
  );

  const updateDepartmentsData = useSelector(
    (state) => state.adminReducer.updateDepartmentsData
  );

  const updateSkillsData = useSelector(
    (state) => state.adminReducer.updateSkillsData
  );
  const roleDownloadData = useSelector(
    (state) => state.adminReducer.downloadCreateRoleTemplateExcelFile
  );
  const uploadeRoleData = useSelector(
    (state) => state.adminReducer.createRoleFromExcel
  );

  const handleCloseDialogAdd = () => {
    setOpenDialogAdd(false);
  };

  const onAddClick = () => {
    setNewValue("");
    setSelectedDepartment([]);
    setRoleCode("");
    setOpenDialogAdd(true);
  };

  const onAddRoleClick = () => {
    if (newValue.toString().trim() === "") {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter new ${getHeaderTitle().toLowerCase()}`);
      return;
    }
    if (newValue.toString().trim().length > 80) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(
        `${
          getHeaderTitle().charAt(0).toUpperCase() + getHeaderTitle().slice(1)
        } should not have more than 80 characters`
      );
      return;
    }
    if (
      tableData.find(
        (val) =>
          val[keys.value].toLowerCase() ===
          newValue.toString().trim().toLowerCase()
      )
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(
        `${getHeaderTitle()} already exists for the selected department`
      );
      return;
    }
    if (
      tableData.filter(
        (val) =>
          val.role_code.toLowerCase() ===
          roleCode.toString().trim().toLowerCase()
      ).length > 0
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Two role shouldn't have same role code`);
      return;
    }
    const maxIndex = Math.max(...tableData.map((o) => o.tempId));
    let depName = "";
    departmentsList.forEach((val) => {
      if (selectedDepartment.indexOf(val.department_id) >= 0)
        depName += val.department + ",";
    });
    if (depName !== "") depName = depName.substring(0, depName.length - 1);
    setTableData([
      {
        [keys.value]: newValue,
        role_code: roleCode,
        created_by: created_by,
        created_date: new Date(),
        is_active: true,
        [keys.parent]: null,
        tempId: maxIndex + 1,
        row_order: 0,
        department_name: depName,
        department_id: selectedDepartment.join(","),
      },
      ...tableData,
    ]);
    setIsEnabled(true);
    setOpenDialogAdd(false);
  };

  const onCancelClick = () => {
    setOpenDialogAdd(false);
  };

  const onRoleCodeChange = (e) => {
    setRoleCode(e.target.value);
  };

  const compareDepartment = (a, b) => {
    if (
      a.department.toString().toLowerCase() <
      b.department.toString().toLowerCase()
    ) {
      return -1;
    }
    if (
      a.department.toString().toLowerCase() >
      b.department.toString().toLowerCase()
    ) {
      return 1;
    }
    return 0;
  };

  const sortDepartments = (data) => {
    if (data && data.length > 0) {
      const sortData = JSON.parse(JSON.stringify(data));
      sortData.sort(compareDepartment);
      return sortData;
    }
    return [];
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const onSearchChange = (e) => {
    setPage(0);
    setSearchText(e.target.value);
  };

  const toggleDrawerUpload = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawerUpload(open);
  };

  const compare = (a, b) => {
    let key = "";
    if (type === "Locations") key = "location";
    if (type === "Roles") key = "role";
    if (type === "Skills") key = "skill";
    if (type === "Departments") key = "department";
    const valueA = a[key] || "";
    const valueB = b[key] || "";
    if (valueA.toLowerCase() < valueB.toLowerCase()) {
      return -1;
    }
    if (valueA.toLowerCase() > valueB.toLowerCase()) {
      return 1;
    }
    return 0;
  };

  const filterData = () => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    if (searchText.trim() !== "") {
      return changedData.filter(
        (val) =>
          val[keys.value]
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase()) ||
          (type === "Roles" &&
            val.role_code
              .toString()
              .trim()
              .toLowerCase()
              .includes(searchText.toString().trim().toLowerCase())) ||
          (type === "Roles" &&
            val.department_name
              .toString()
              .trim()
              .toLowerCase()
              .includes(searchText.toString().trim().toLowerCase()))
      );
    }
    return changedData;
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  useEffect(() => {
    setIsEnabled(false);
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.sort(compare);
    changedData.forEach((val, i) => {
      val.isEdit = false;
      val.tempId = i + 1;
    });
    setPage(0);
    setRowsPerPage(10);
    setTableData(changedData);
    if (type === "Locations")
      setKeys({
        id: "location_id",
        value: "location",
        parent: "parent_location_id",
      });
    if (type === "Roles")
      setKeys({ id: "role_id", value: "role", parent: "parent_role_id" });
    if (type === "Skills")
      setKeys({ id: "skill_id", value: "skill", parent: "parent_skill_id" });
    if (type === "Departments")
      setKeys({
        id: "department_id",
        value: "department",
        parent: "parent_department_id",
      });
  }, [data, type]);

  const onStatusChange = (id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val.is_active = !val.is_active;
    });
    setTableData(changedData);
    setIsEnabled(true);
  };
  const changeEditStatus = (id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    const editedItem = changedData.find((val) => val.tempId === id);
    if (editedItem) {
      const editedValueLowerCase = editedItem[keys.value].toLowerCase();
      const exists = changedData.some((otherItem) => {
        if (editedItem.tempId !== otherItem.tempId) {
          const otherValueLowerCase = otherItem[keys.value].toLowerCase();
          return editedValueLowerCase === otherValueLowerCase;
        }
        return false;
      });
      // if (exists) {
      //   setEmptyErrMsg(true);
      //   setMsgType("error");
      //   setMsgText(`${getHeaderTitle()} already exists`);
      //   setLoading(false);
      //   return;
      // }
    }
    changedData.forEach((val) => {
      if (val.tempId === id) val.isEdit = !val.isEdit;
    });
    setTableData(changedData);
  };
  const onChangeValue = (e, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val[keys.value] = e.target.value;
    });
    setTableData(changedData);
    setIsEnabled(true);
  };

  const onChangeDepartment = (value, id) => {
    if (value.length > 0) {
      const changedData = JSON.parse(JSON.stringify(tableData));
      changedData.forEach((val) => {
        if (val.tempId === id) {
          val.department_id = value.join(",");
          let depName = "";
          departmentsList.forEach((val) => {
            if (value.indexOf(val.department_id) >= 0)
              depName += val.department + ",";
          });
          if (depName !== "")
            depName = depName.substring(0, depName.length - 1);
        }
      });
      setTableData(changedData);
      setIsEnabled(true);
    }
  };

  const onChangeValueNew = (e) => {
    setNewValue(e.target.value);
  };

  const handleDepartmentSelect = (value) => {
    setSelectedDepartment(value);
  };

  const onAddValue = () => {
    if (newValue.toString().trim() === "") {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter new ${getHeaderTitle().toLowerCase()}`);
      return;
    }
    if (newValue.toString().trim().length > 80) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(
        `${
          getHeaderTitle().charAt(0).toUpperCase() + getHeaderTitle().slice(1)
        } should not have more than 80 characters`
      );
      return;
    }
    if (
      tableData.filter(
        (val) =>
          val[keys.value].toLowerCase() ===
          newValue.toString().trim().toLowerCase()
      ).length > 0
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`${getHeaderTitle()} already exists`);
      return;
    }
    const maxIndex = Math.max(...tableData.map((o) => o.tempId));
    setTableData([
      {
        [keys.value]: newValue,
        created_by: created_by,
        created_date: new Date(),
        is_active: true,
        [keys.parent]: null,
        tempId: maxIndex + 1,
        row_order: 0,
        department_name:
          (selectedDepartment &&
            departmentsList.find((d) => d.department_id === selectedDepartment)
              ?.department) ||
          "",
        department_id: selectedDepartment,
      },
      ...tableData,
    ]);
    setNewValue("");
    setSelectedDepartment([]);
    setIsEnabled(true);
  };

  const updateData = () => {
    let isValid = true;
    tableData.forEach((val) => {
      if (val[keys.value].trim().length > 80) {
        isValid = false;
      }
    });

    if (!isValid) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(
        `${
          getHeaderTitle().charAt(0).toUpperCase() + getHeaderTitle().slice(1)
        } should not have more than 80 characters`
      );
      return;
    }

    setLoading(true);
    if (tableData.filter((item) => !item[keys.id]).length > 0) setIsAdded(true);
    const editedValueExists = tableData.some((existingItem) => {
      if (existingItem.isEdit) {
        const editedValueLowerCase = existingItem[keys.value].toLowerCase();
        return tableData.some((otherItem) => {
          if (existingItem.tempId !== otherItem.tempId) {
            const otherValueLowerCase = otherItem[keys.value].toLowerCase();
            return editedValueLowerCase === otherValueLowerCase;
          }
          return false;
        });
      }
      return false;
    });
    if (editedValueExists) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`${getHeaderTitle()} already exists`);
      setLoading(false);
      return;
    }
    if (type === "Locations") {
      tableData.forEach((val) => {
        if (val.location.trim() === "" && isValid) isValid = false;
      });
    }
    if (type === "Roles") {
      tableData.forEach((val) => {
        if (val.role.trim() === "" && isValid) isValid = false;
      });
    }
    if (type === "Skills") {
      tableData.forEach((val) => {
        if (val.skill.trim() === "" && isValid) isValid = false;
      });
    }
    if (type === "Departments") {
      tableData.forEach((val) => {
        if (val.department.trim() === "" && isValid) isValid = false;
      });
    }
    if (!isValid) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`${getHeaderTitle()} cannot be empty`);
      setLoading(false);
      return false;
    }
    setLoading(true);
    setIsValueUpdated(true);
    if (tableData.filter((item) => !item[keys.id]).length > 0) setIsAdded(true);
    if (type === "Locations") {
      dispatch(updateGeneralSettingsLocation(tableData));
    }
    if (type === "Roles") {
      dispatch(updateRoles(tableData));
    }
    if (type === "Skills") {
      dispatch(updateSkills(tableData));
    }
    if (type === "Departments") {
      dispatch(updateDepartments(tableData));
    }
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const downloadExcel = () => {
    setIsDownloadClick(true);
    dispatch(downloadCreateRoleTemplateExcelFile());
    setLoading(true);
  };
  const uploadFile = (formData) => {
    dispatch(createRoleFromExcel(formData));
    setLoading(true);
    setIsUploadClick(true);
  };
  useEffect(() => {
    if (roleDownloadData.type && isDownloadClick) {
      setLoading(false);
      downloadFile(roleDownloadData, "createRole");
      setIsDownloadClick(false);
    }
  }, [roleDownloadData]);

  useEffect(() => {
    if (
      isValueUpdated &&
      ((upadteLocationSettingsData.status &&
        upadteLocationSettingsData.status === 200) ||
        (updateDepartmentsData.status &&
          updateDepartmentsData.status === 200) ||
        (updateRolesData.status && updateRolesData.status === 200) ||
        (updateSkillsData.status && updateSkillsData.status === 200))
    ) {
      setLoading(false);
      setIsValueUpdated(false);
      setIsEnabled(false);
      setMsgType("Success");
      setEmptyErrMsg(true);
      if (isAdded) {
        setMsgText(`${getHeaderTitle()}(s) added successfully`);
        setIsAdded(false);
      } else setMsgText(`${type} updated successfully`);
      if (type === "Locations") {
        dispatch(getGeneralSettingsLocation());
      }
      if (type === "Roles") {
        dispatch(getRoles());
      }
      if (type === "Skills") {
        dispatch(getSkills());
      }
      if (type === "Departments") {
        dispatch(getAdminDepartments());
      }
    }
  }, [
    isValueUpdated,
    upadteLocationSettingsData,
    updateDepartmentsData,
    updateRolesData,
    updateSkillsData,
  ]);

  useEffect(() => {
    if (
      isValueUpdated &&
      ((updateDepartmentsData.status && updateDepartmentsData.status === 400) ||
        (updateRolesData.status && updateRolesData.status === 400) ||
        (updateSkillsData.status && updateSkillsData.status === 400))
    ) {
      setLoading(false);
      setIsValueUpdated(false);
      setIsEnabled(false);
      setMsgType("error");
      setEmptyErrMsg(true);
      let errorMessage = "";
      if (updateSkillsData.status === 400 && updateSkillsData.message) {
        errorMessage = updateSkillsData.message;
        dispatch(getSkills());
      } else if (
        updateDepartmentsData.status === 400 &&
        updateDepartmentsData.message
      ) {
        errorMessage = updateDepartmentsData.message;
      } else if (updateRolesData.status === 400 && updateRolesData.message) {
        errorMessage = updateRolesData.message;
        dispatch(getRoles());
      }
      setMsgText(errorMessage);
    }
  }, [
    isValueUpdated,
    updateDepartmentsData,
    updateRolesData,
    updateSkillsData,
  ]);

  useEffect(() => {
    if (uploadeRoleData.type && isUploadClick) {
      setLoading(false);
      setIsUploadClick(false);
      setEmptyErrMsg(true);
      setMsgText("File processed successfully. Please check");
      downloadFile(uploadeRoleData, "uploadedFile");
      setOpenDrawerUpload(false);
      setMsgType("success");
    }
  }, [uploadeRoleData]);
  const getHeaderTitle = () => {
    if (type === "Locations") return "Location";
    if (type === "Roles") return "Role";
    if (type === "Skills") return "Skill";
    if (type === "Departments") return "Department";
    return ``;
  };

  const cancelUpdate = () => {
    setIsEnabled(false);
    if (type === "Locations") {
      dispatch(getGeneralSettingsLocation());
    }
    if (type === "Roles") {
      dispatch(getRoles());
    }
    if (type === "Skills") {
      dispatch(getSkills());
    }
    if (type === "Departments") {
      dispatch(getAdminDepartments());
    }
  };

  return (
    <Paper elevation={0} className={classes.tablePaper}>
      <Grid container className={classes.searchSection} spacing={0}>
        <Grid item lg={3}>
          <FormControl variant="outlined" className={classes.searchControl}>
            <OutlinedInput
              className={classes.searchTextField}
              type="text"
              placeholder="Search"
              onChange={(e) => onSearchChange(e)}
              value={searchText}
              endAdornment={
                <InputAdornment position="start">
                  <SearchIcon className={classes.searchIcon} />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        <Grid item lg={6} style={{ position: "relative" }}>
          {type !== "Roles" && (
            <FormControl variant="outlined" className={classes.newValueControl}>
              <OutlinedInput
                className={classes.locationField}
                type="text"
                placeholder={`Add new ${getHeaderTitle().toLowerCase()}`}
                onChange={(e) => onChangeValueNew(e)}
                value={newValue}
              />
            </FormControl>
          )}
          {type !== "Roles" && (
            <Button
              className={classes.addBtn}
              variant="contained"
              color="primary"
              onClick={onAddValue}
              disabled={
                type === "Roles" ? selectedDepartment.length > 0 : false
              }
            >
              Add
            </Button>
          )}
          {type === "Roles" && (
            <Button
              className={classes.addRoleBtn}
              variant="contained"
              color="primary"
              onClick={onAddClick}
            >
              Add Role
            </Button>
          )}
          {type === "Roles" && (
            <>
              <span
                style={{
                  cursor: "pointer",
                  marginRight: "6px",
                  position: "absolute",
                  right: "-80px",
                  top: "6px",
                }}
                title="Download Template"
                onClick={() => downloadExcel()}
              >
                <DownloadTemplateIcon background="#0070D2" color="#fff" />
              </span>
              <span
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  right: "-108px",
                  top: "-2px",
                }}
                title="Upload Roles"
                onClick={toggleDrawerUpload(true)}
              >
                <UploadIcon background="#0070D2" color="#fff" />
              </span>
            </>
          )}
        </Grid>
        <Grid item lg={3}>
          <Button
            variant="outlined"
            className={classes.cancelBtn}
            color="primary"
            onClick={() => cancelUpdate()}
            disabled={!isEnabled}
            style={{ marginTop: "4px", float: "right" }}
          >
            Cancel
          </Button>
          <Button
            className={classes.updateBtn}
            variant="contained"
            color="primary"
            onClick={updateData}
            disabled={!isEnabled}
            style={{ marginTop: "4px", float: "right" }}
          >
            Update
          </Button>
        </Grid>
      </Grid>
      {filterData(tableData).length > 0 ? (
        <table className="generalSettingsTable">
          <thead>
            <tr>
              <td>{getHeaderTitle()}</td>
              {type === "Roles" && <td>Role Code</td>}
              {type === "Roles" && <td>Department</td>}
              <td>Enabled</td>
            </tr>
          </thead>
          <tbody>
            {filterData(tableData)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tableItem, i) => (
                <tr key={i}>
                  <td>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <FormControl
                          variant="outlined"
                          className={classes.editText}
                        >
                          <OutlinedInput
                            className={classes.editTextField}
                            type="text"
                            onChange={(e) => onChangeValue(e, tableItem.tempId)}
                            value={tableItem[keys.value]}
                            inputProps={{
                              style: {
                                padding: "0 0 0 2px",
                              },
                            }}
                          />
                        </FormControl>
                      ) : (
                        tableItem[keys.value]
                      )}
                    </span>

                    {tableItem.isEdit ? (
                      <span className={classes.checkCircleIconSpan}>
                        <CheckCircleIcon
                          className={classes.checkCircleIcon}
                          onClick={() => changeEditStatus(tableItem.tempId)}
                        />
                      </span>
                    ) : (
                      <span className="settinsTableEdit">
                        <EditIcon
                          className={classes.editIcon}
                          onClick={() => changeEditStatus(tableItem.tempId)}
                        />
                      </span>
                    )}
                  </td>
                  {type === "Roles" && (
                    <>
                      <td>
                        <span style={{ float: "left" }}>
                          {tableItem["role_code"]}
                        </span>
                      </td>
                      <td>
                        {tableItem.isEdit ? (
                          <AntSelect
                            mode="multiple"
                            className={classes.departmentDropdown}
                            value={
                              tableItem.department_id !== ""
                                ? tableItem.department_id
                                    .split(",")
                                    .map((val) => parseInt(val))
                                : []
                            }
                            onChange={(value) =>
                              onChangeDepartment(value, tableItem.tempId)
                            }
                          >
                            {sortDepartments(departmentsList).map(
                              (department) => (
                                <Option
                                  key={department.department_id}
                                  value={department.department_id}
                                >
                                  {department.department}
                                </Option>
                              )
                            )}
                          </AntSelect>
                        ) : (
                          tableItem.department_name
                        )}
                      </td>
                    </>
                  )}
                  <td>
                    <Checkbox
                      className="customCheckBox"
                      color="primary"
                      checked={tableItem.is_active}
                      onChange={() => onStatusChange(tableItem.tempId)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{ textAlign: "center", padding: "20px 0", fontWeight: 600 }}
        >
          No results found
        </div>
      )}
      {filterData(tableData).length > 0 && (
        <Grid container className={classes.paginationSection} spacing={0}>
          <Grid item lg={12}>
            <div style={{ float: "right", marginTop: "6px" }}>
              <Pagination
                count={Math.ceil(filterData(tableData).length / rowsPerPage)}
                showFirstButton
                showLastButton
                page={page + 1}
                onChange={handleChangePage}
                color="primary"
                style={{ float: "right" }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    page={getPaginationPageNumber(
                      item.page - 1,
                      filterData(tableData).length,
                      rowsPerPage
                    )}
                  />
                )}
              />
            </div>
            <div style={{ float: "right", marginTop: "6px" }}>
              <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
              <FormControl className="tableRowsDdl">
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  input={<BootstrapInput />}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
      <Drawer
        anchor="right"
        open={openDrawerUpload}
        onClose={toggleDrawerUpload(false)}
      >
        <div className={classes.drawerDataSection}>
          <div className={classes.drawerTitle}>Bulk Upload</div>
          <div className={classes.uploadDescription}>
            Please Drag and Drop or select the required files
          </div>
          <div
            className={classes.closeSection}
            onClick={toggleDrawerUpload(false)}
          >
            <CloseIcon className={classes.closeIcon} />
          </div>
          <FileUpload getFormData={uploadFile} />
        </div>
      </Drawer>
      <Dialog
        open={openDialogAdd}
        onClose={handleCloseDialogAdd}
        aria-labelledby="max-width-dialog-title"
        // disableBackdropClick
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span
              className={classes.closeIconAdd}
              onClick={() => setOpenDialogAdd(false)}
            >
              x
            </span>
            <div className={classes.addColumnTitle}>Add Role</div>
          </div>
          <Grid container spacing={2}>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Role<span className={classes.required}>*</span>
              </div>
              <CustomTextField
                selectedValue={newValue}
                onChangeItem={onChangeValueNew}
                labelVal="Role"
                id="roleName"
              />
            </Grid>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Role Code<span className={classes.required}>*</span>
              </div>
              <CustomTextField
                selectedValue={roleCode}
                onChangeItem={onRoleCodeChange}
                labelVal="Role Code"
                id="roleCode"
              />
            </Grid>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Department<span className={classes.required}>*</span>
              </div>
              <AntSelect
                mode="multiple"
                className={classes.departmentDropdownPopup}
                placeholder="Select a department"
                onChange={(value) => handleDepartmentSelect(value)}
                value={selectedDepartment}
              >
                {sortDepartments(departmentsList).map((department) => (
                  <Option
                    key={department.department_id}
                    value={department.department_id}
                  >
                    {department.department}
                  </Option>
                ))}
              </AntSelect>
            </Grid>
          </Grid>
          <div className={classes.popupBtnsAdd}>
            <Button
              className={classes.saveBtn}
              variant="contained"
              color="primary"
              onClick={onAddRoleClick}
              disabled={
                newValue.trim() === "" ||
                roleCode.trim() === "" ||
                selectedDepartment.length === 0
              }
            >
              Add
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Paper>
  );
};

export default SettingsList;
